import { render, staticRenderFns } from "./ChartInfo.vue?vue&type=template&id=5f3754c8"
import script from "./ChartInfo.vue?vue&type=script&lang=js"
export * from "./ChartInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3430498393/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3754c8')) {
      api.createRecord('5f3754c8', component.options)
    } else {
      api.reload('5f3754c8', component.options)
    }
    module.hot.accept("./ChartInfo.vue?vue&type=template&id=5f3754c8", function () {
      api.rerender('5f3754c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/ChartInfo.vue"
export default component.exports